// test486
(486 && 0);
